<alaris-card>
	@if (tRows.length > 0 || tRows.length === 0 && state.isFiltersApplied) {
	<div class="table-management">
		<div class="left">
			<span class="total">{{ totalTitle | translate }}: {{ total }}</span>
			<button (click)="editTableFilter()" alaris-button bType="outline" size="lg">
				<alaris-icon name="icon-filter-vertical"></alaris-icon>
				{{ enableButtons.filters.title | translate }}
				@if (state.isFiltersApplied) {
				<div class="indicator"></div>
				}
			</button>
		</div>
		<div class="right">
			<button (click)="refresh()" alaris-button bType="outline" size="lg">
				<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
				{{ 'actions.refresh_page' | translate }}
			</button>
			<button
				(click)="export()"
				[disabled]="!!(exporting$ | async)"
				alaris-button
				bType="outline"
				size="lg"
				[disabled]="!this.user.allowed(['mdtask.edit'])">
				@if (exporting$ | async) {
				<alaris-spinner></alaris-spinner>
				} @else {
				<alaris-icon name="icon-export"></alaris-icon>
				}
				{{ 'gl.export' | translate }}
			</button>
			<button
				(click)="createNewTask()"
				alaris-button
				bType="primary"
				size="lg"
				[disabled]="!this.user.allowed(['mdtask.edit'])">
				<alaris-icon class="in-primary" name="icon-plus"></alaris-icon>
				{{ 'manual_dipping.add' | translate }}
			</button>
		</div>
	</div>
	}
	<div [alarisLoading]="loading$" alarisHorizontalOverflow class="content">
		@if (tRows.length === 0 && !state.isFiltersApplied) {
		<app-empty-table
			type="md-task"
			[disabled]="!this.user.allowed(['mdtask.edit'])"
			(newMdtask)="createNewTask()"></app-empty-table>
		} @else {
		<alaris-table
			(filtersChange)="_applyFilter($event)"
			(sortingChange)="_applySorting($event)"
			[filters]="state.filters()"
			[dblClickRowAction]="dblClickRowAction.bind(this)"
			[dropDownRowActions]="dropDownRowActions"
			[rowActions]="rowActions"
			[tHeaders]="tHeaders()"
			[tRows]="tRows"
			[templates]="{mdTaskID, author, status, numbers}"
			[resizable]="resizable"
			alarisOverflowFader></alaris-table>
		}
	</div>
	<div class="footer">
		<alaris-pagination
			(page)="_pageChange($event)"
			[activePage]="activePage"
			[class.without-table-bar]="selection !== null && selection.length === 0"
			[hidden]="total === 0"
			[pageSizeOptions]="pageSizeOptions"
			[pageSize]="pageSize"
			[total]="total"
			class="pagination"></alaris-pagination>
	</div>
</alaris-card>

<ng-template #author [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	@let firstName = data.author?.details?.firstName; @let lastName = data.author?.details?.lastName; @if (firstName &&
	lastName) {
	<span>{{ firstName }}&nbsp;{{ lastName }}</span>
	} @else {
	<span>
		{{ data.author?.login }}
	</span>
	}
</ng-template>

<ng-template #mdTaskID [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<div class="mdTaskID">
		<button alaris-button bType="primary" [ripple]="false" [size]="'xl'">
			<alaris-icon name="icon-package" class="source-icon"></alaris-icon>
		</button>
		<div>
			<div class="task-id">DD-{{ data.mdTaskID }}</div>
			<div>{{ data.sources.join(', ') }}</div>
		</div>
	</div>
</ng-template>

<ng-template #status [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<app-manual-dipping-status [mdTask]="data"></app-manual-dipping-status>
</ng-template>

<ng-template #numbers [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<div class="task-numbers">
		@for (number of data.numbers; track number) {
		<alaris-tag>{{ number }}</alaris-tag>
		}
	</div>
</ng-template>
